var _style, _defs, _clipPath, _g, _defs2, _clipPath2, _g2, _path, _path2, _defs3, _clipPath3, _g3, _defs4, _clipPath4, _g4, _path3, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgButtonStoreGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "button-store-google_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 260 98.4",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".button-store-google_svg__st3{fill:#fff}.button-store-google_svg__st7{fill:#fcd807}.button-store-google_svg__st11{fill:#ea414a}.button-store-google_svg__st16{fill:#74c269}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_1_",
    d: "M20.6 16.7h217v63.8h-217z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_1_",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230 79.8H28.8c-4.1 0-7.4-3.3-7.4-7.4V24.7c0-4.1 3.3-7.4 7.4-7.4H230c4.1 0 7.4 3.3 7.4 7.4v47.7c0 4.1-3.3 7.4-7.4 7.4"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_3_",
    d: "M20.6 15.7h217.6v64.8H20.6z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_3_",
    overflow: "visible"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8 18.1c-3.6 0-6.6 2.9-6.6 6.6v47.7c0 3.6 2.9 6.6 6.6 6.6H230c3.6 0 6.6-2.9 6.6-6.6V24.7c0-3.6-2.9-6.6-6.6-6.6H28.8zM230 80.6H28.8c-4.5 0-8.2-3.7-8.2-8.2V24.7c0-4.5 3.7-8.2 8.2-8.2H230c4.5 0 8.2 3.7 8.2 8.2v47.7c0 4.5-3.6 8.2-8.2 8.2",
    fill: "#a7a9ab"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "button-store-google_svg__st3",
    d: "M192.8 64.8h3V44.7h-3v20.1zm27-12.8l-3.4 8.7h-.1l-3.6-8.7h-3.2l5.4 12.2-3.1 6.8h3.1l8.2-19h-3.3zm-17 10.5c-1 0-2.4-.5-2.4-1.7 0-1.6 1.7-2.1 3.2-2.1 1.3 0 1.9.3 2.7.7-.2 1.8-1.8 3.1-3.5 3.1m.4-11c-2.2 0-4.4 1-5.4 3.1l2.7 1.1c.6-1.1 1.6-1.5 2.7-1.5 1.6 0 3.1.9 3.2 2.6v.2c-.5-.3-1.7-.8-3.1-.8-2.9 0-5.8 1.6-5.8 4.5 0 2.7 2.4 4.4 5 4.4 2 0 3.1-.9 3.8-2h.1v1.6h2.9V57c0-3.5-2.7-5.5-6.1-5.5m-18.6 2.9h-4.3v-6.9h4.3c2.2 0 3.5 1.9 3.5 3.4 0 1.6-1.2 3.5-3.5 3.5m0-9.7h-7.2v20.1h3v-7.6h4.2c3.3 0 6.6-2.4 6.6-6.2s-3.3-6.3-6.6-6.3m-39.3 17.8c-2.1 0-3.8-1.7-3.8-4.1 0-2.4 1.7-4.2 3.8-4.2 2 0 3.7 1.8 3.7 4.2 0 2.4-1.6 4.1-3.7 4.1m3.5-9.4h-.1c-.7-.8-2-1.5-3.6-1.5-3.4 0-6.6 3-6.6 6.9 0 3.8 3.1 6.8 6.6 6.8 1.6 0 2.9-.7 3.6-1.6h.1v1c0 2.6-1.4 4-3.7 4-1.8 0-3-1.3-3.4-2.4l-2.6 1.1c.8 1.8 2.7 4 6.1 4 3.5 0 6.5-2.1 6.5-7.1V52h-2.9v1.1zm4.9 11.7h3V44.7h-3v20.1zm7.4-6.6c-.1-2.6 2-4 3.6-4 1.2 0 2.2.6 2.5 1.4l-6.1 2.6zm9.4-2.3c-.6-1.5-2.3-4.4-5.9-4.4-3.5 0-6.4 2.8-6.4 6.8 0 3.8 2.9 6.8 6.8 6.8 3.1 0 4.9-1.9 5.7-3l-2.3-1.6c-.8 1.1-1.8 1.9-3.4 1.9s-2.6-.7-3.3-2.1l9.1-3.8-.3-.6zm-72.9-2.3v2.9h6.9c-.2 1.6-.8 2.8-1.6 3.7-1 1-2.6 2.1-5.4 2.1-4.3 0-7.6-3.4-7.6-7.7s3.3-7.7 7.6-7.7c2.3 0 4 .9 5.2 2.1l2-2.1c-1.7-1.7-4-2.9-7.3-2.9-5.9 0-10.8 4.8-10.8 10.6s4.9 10.6 10.8 10.6c3.2 0 5.5-1 7.4-3 1.9-1.9 2.5-4.6 2.5-6.8 0-.7-.1-1.3-.2-1.8h-9.5zm17.8 8.9c-2.1 0-3.9-1.7-3.9-4.1 0-2.5 1.8-4.1 3.9-4.1s3.9 1.7 3.9 4.1-1.8 4.1-3.9 4.1m0-11c-3.8 0-6.9 2.9-6.9 6.8s3.1 6.8 6.9 6.8 6.9-2.9 6.9-6.8-3.1-6.8-6.9-6.8m15 11c-2.1 0-3.9-1.7-3.9-4.1 0-2.5 1.8-4.1 3.9-4.1s3.9 1.7 3.9 4.1c0 2.4-1.8 4.1-3.9 4.1m0-11c-3.8 0-6.9 2.9-6.9 6.8s3.1 6.8 6.9 6.8 6.9-2.9 6.9-6.8-3.1-6.8-6.9-6.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6 28.7c-.5.5-.7 1.3-.7 2.3v35.5c0 1 .3 1.8.7 2.3l.1.1L57.6 49v-.5L37.7 28.6",
    fill: "#59c9f4"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_5_",
    d: "M57.6 41.9h16.8v13.8H57.6z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_5_",
    overflow: "visible"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_6_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_7_",
    className: "button-store-google_svg__st7",
    d: "M57.6 48.5v.5l6.6 6.6.1-.1 7.9-4.5c2.2-1.3 2.2-3.4 0-4.6l-7.9-4.5-.2-.1-6.5 6.7z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_8_",
    d: "M57.6 48.5v.5l6.6 6.6.1-.1 7.9-4.5c2.2-1.3 2.2-3.4 0-4.6l-7.9-4.5-.2-.1-6.5 6.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_8_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_10_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_9_",
    className: "button-store-google_svg__st7",
    d: "M57.6 48.5v.5l6.6 6.6.1-.1 7.9-4.5c2.2-1.3 2.2-3.4 0-4.6l-7.9-4.5-.2-.1-6.5 6.7z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_11_",
    d: "M57.6 48.5v.5l6.6 6.6.1-.1 7.9-4.5c2.2-1.3 2.2-3.4 0-4.6l-7.9-4.5-.2-.1-6.5 6.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_11_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_12_)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 36.9 115.94)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 180,
    height: 140,
    id: "button-store-google_svg__image5",
    xlinkHref: "4CC2853E62634763.png",
    transform: "matrix(.09433 0 0 -.09433 57.283 55.374)",
    overflow: "visible"
  })))))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_14_",
    d: "M37.6 48.7h27v21h-27z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_14_",
    overflow: "visible"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_16_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_13_",
    className: "button-store-google_svg__st11",
    d: "M37.6 68.8c.7.8 2 .9 3.3.1l23.5-13.3-6.8-6.8-20 20z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_18_",
    d: "M37.6 68.8c.7.8 2 .9 3.3.1l23.5-13.3-6.8-6.8-20 20z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_19_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_18_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_19_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_15_",
    className: "button-store-google_svg__st11",
    d: "M37.6 68.8c.7.8 2 .9 3.3.1l23.5-13.3-6.8-6.8-20 20z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_20_",
    d: "M37.6 68.8c.7.8 2 .9 3.3.1l23.5-13.3-6.8-6.8-20 20z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_21_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_20_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_21_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_17_",
    className: "button-store-google_svg__st11",
    d: "M47.3 39L27.2 59.1 51 82.9l20.1-20.1L47.3 39zm3.7-3.7L47.3 39l23.8 23.8 3.7-3.7L51 35.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_22_",
    d: "M47.3 39L27.2 59.1 51 82.9l20.1-20.1L47.3 39zm3.7-3.7L47.3 39l23.8 23.8 3.7-3.7L51 35.3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_22_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_24_)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 16.9 129.74)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 280,
    height: 220,
    id: "button-store-google_svg__image8",
    xlinkHref: "4CC2853E62634761.png",
    transform: "matrix(.09532 0 0 -.09532 37.628 69.607)",
    overflow: "visible"
  }))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "button-store-google_svg__st3",
    d: "M94.5 29.8c-.6-.5-1.4-.9-2.3-.9-2 0-3.5 1.6-3.5 3.6s1.5 3.6 3.5 3.6c1.7 0 2.9-1 3-2.6h-2.7v-1.1h4.1c0 3.3-1.8 4.9-4.5 4.9s-4.8-2.2-4.8-4.8c0-2.7 2.1-4.9 4.8-4.9 1.2 0 2.4.5 3.2 1.2M104.1 27.8V29h-4.3v3h3.8v1.2h-3.8v2.9h4.5v1.2h-5.7v-9.5M112.4 27.8V29h-2.9v8.3h-1.3V29h-2.9v-1.2M117.2 37.3h1.3v-9.5h-1.3v9.5zM127.2 27.8V29h-2.9v8.3H123V29h-2.9v-1.2M136.2 36.2c2 0 3.5-1.6 3.5-3.6s-1.5-3.6-3.5-3.6-3.5 1.6-3.5 3.6 1.5 3.6 3.5 3.6m0-8.5c2.7 0 4.8 2.2 4.8 4.9s-2.1 4.8-4.8 4.8-4.8-2.2-4.8-4.8c0-2.7 2.1-4.9 4.8-4.9M148.6 37.3l-4.3-7.1v7.1H143v-9.5h1.3l4.3 7.1v-7.1h1.3v9.5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_26_",
    d: "M37.6 27.7h27v21h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_26_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_28_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_23_",
    className: "button-store-google_svg__st16",
    d: "M37.6 28.7l20 20 6.8-6.8-23.5-13.3c-.6-.4-1.3-.5-1.8-.5-.6 0-1.1.2-1.5.6"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_29_",
    d: "M37.6 28.7l20 20 6.8-6.8-23.5-13.3c-.6-.4-1.3-.5-1.8-.5-.6 0-1.1.2-1.5.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_29_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_30_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_25_",
    className: "button-store-google_svg__st16",
    d: "M37.6 28.7l20 20 6.8-6.8-23.5-13.3c-.6-.4-1.3-.5-1.8-.5-.6 0-1.1.2-1.5.6"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_31_",
    d: "M37.6 28.7l20 20 6.8-6.8-23.5-13.3c-.6-.4-1.3-.5-1.8-.5-.6 0-1.1.2-1.5.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_31_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_32_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_27_",
    className: "button-store-google_svg__st16",
    d: "M27.2 38.4l13.2 13.2 23.8-23.8L51 14.6 27.2 38.4zm13.2 13.2L51 62.2l23.8-23.8-10.6-10.6-23.8 23.8z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "button-store-google_svg__SVGID_33_",
    d: "M27.2 38.4l13.2 13.2 23.8-23.8L51 14.6 27.2 38.4zm13.2 13.2L51 62.2l23.8-23.8-10.6-10.6-23.8 23.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "button-store-google_svg__SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#button-store-google_svg__SVGID_33_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#button-store-google_svg__SVGID_34_)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 16.9 109.04)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 280,
    height: 210,
    id: "button-store-google_svg__image11",
    xlinkHref: "4CC2853E62634767.png",
    transform: "matrix(.09698 0 0 -.09698 37.396 48.604)",
    overflow: "visible"
  })))))))));
}

export default SvgButtonStoreGoogle;